import styled from "styled-components";
import Text from "../../atoms/Text";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
  width: 100%;
`

const ErrorableInputWrapper = ({ children, $error, message }) => {
  return (
    <Wrapper>
      {children}
      {message && (
        <Text 
          variant="caption" 
          color={$error ? "error" : "alternative"}>
          {message}
        </Text>
      )}
    </Wrapper>
  );
};

export default ErrorableInputWrapper;